<template>
  <Loading v-if="loading" />
  <div class="strongAuthenticationRegister">
    <img
      class="strongAuthenticationRegister-img"
      :src="
        isFailed
          ? require('@/assets/icons/AuthenticationFailedRegister.svg')
          : require('@/assets/icons/AuthenticationSuccessRegister.svg')
      "
      alt=""
    />
    <p class="strongAuthenticationRegister-title">
      {{
        isFailed
          ? $t('authenticationRegisterFailed')
          : $t('authenticationRegisterSuccess')
      }}
    </p>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

@Options({
  name: 'StrongAuthenticationRegister',
  components: {
    Loading
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState('account', ['status']),
    isFailed() {
      return this.status.message;
    }
  },
  created() {
    this.show();
  },
  methods: {
    ...mapActions('account', ['authorizeUserVieStrongAuthRedirect']),
    async show() {
      this.loading = true;

      const payload = {
        verificationData: window.location.search
      };

      await this.authorizeUserVieStrongAuthRedirect(payload);

      this.loading = false;
    }
  }
})
export default class StrongAuthenticationRegister extends Vue {}
</script>

<style lang="scss" scoped>
.strongAuthenticationRegister {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 280px;
  height: 176px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: $light-grey;
  .strongAuthenticationRegister-img {
    margin-bottom: 20px;
    background-color: $light-grey;
  }
  .strongAuthenticationRegister-title {
    font-size: $fourteenSize;
    line-height: $fourteenSize;
    font-weight: 600;
    background-color: $light-grey;
  }
}
</style>
